module.exports = __webpack_public_path__ + "8c056c7293e5085fe7c94f3053352bd5.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Map/assets/marker-selected.png
// module id = 2735
// module chunks = 0